import { isReservedField } from "../utils/tables";
export default {
    data() {
        return {
            componentItems: [],
            componentFields: [],
        };
    },
    computed: {
        componentListFieldsActive() {
            return this.componentFieldsActive.map((field) => {
                return field.key ? field.key : field;
            });
        },
        componentFieldsActive() {
            return this.componentFields.filter((field) => {
                return field.hasOwnProperty("_active")
                    ? field._active == true
                    : true;
            });
        },
    },
    watch: {
        componentItems(newValue) {
            this.$emit("update:items", newValue);
        },
    },
    methods: {
        getDefaultItem(defaultValue = null) {
            let item = {};
            const defaultValueOriginal = defaultValue;
            this.componentFields.forEach((field) => {
                defaultValue = defaultValueOriginal;
                if (typeof field === "object" && field !== null) {
                    defaultValue = field._defaultValue
                        ? field._defaultValue
                        : defaultValue;
                    if (typeof defaultValue === "function") {
                        defaultValue = defaultValue();
                    }
                }

                if (typeof field === "string" && !isReservedField(field))
                    this.$set(item, field, defaultValue);
                else if (field.key && !isReservedField(field))
                    this.$set(item, field.key, defaultValue);
            });
            return item;
        },

        searchField(fieldKey) {
            return this.componentFields.find(field => field.key === fieldKey);
        },

        addItem() {
            const defaultItem = this.getDefaultItem();
            this.componentItems.push(defaultItem);
            this.$emit("addItem", defaultItem);
        },

        removeItem(index) {
            this.$emit("deforeRemoveItem", { position: index });
            this.componentItems.splice(index, 1);
            this.$emit("removeItem", { position: index });
        },
    },
};
